<script>
export const group = 'Bottom'
export const reuseComponent = true
</script>

<script setup>
import { onMounted, ref } from 'vue'
import { colors } from '../../../tailwindTheme.config.js'
import ContentBar from './shared/ContentBar.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const colorScheme = { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker }

const timelineContentBar = ref(null)
const timelineContentBarOut = ref(null)
const contentBarElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'AppMessageSmall' }).add(timelineContentBar)
})

const { onDisappear } = useDisappearable()
onDisappear(() => gsapTimeline({ name: 'AppMessageSmall - End' }).add(timelineContentBarOut.value()).endInvisible(contentBarElement))

const subtitle = computed(() => {
  if (!props.item.enrichment.message.from?.name) {
    return ''
  }
  if (!props.item.enrichment.message.message && props.item.enrichment.message.image) {
    return `<strong>${props.item.enrichment.message.from.name}</strong> stuurt een foto via de Q-app`
  }
  return `<strong>${props.item.enrichment.message.from.name}</strong> stuurt via de Q-app`
})
</script>

<template>
  <ContentBar
    ref="contentBarElement"
    title="Bericht"
    :subtitle="subtitle"
    :body="item.enrichment.message.message"
    :image="item.enrichment.message.image"
    :colorScheme="colorScheme"
    @timeline="timelineContentBar = $event"
    @timelineOut="timelineContentBarOut = $event"
  />
</template>
